import { render, staticRenderFns } from "./InspectHome.vue?vue&type=template&id=9b04b9b8&scoped=true"
import script from "./InspectHome.vue?vue&type=script&lang=js"
export * from "./InspectHome.vue?vue&type=script&lang=js"
import style0 from "./InspectHome.vue?vue&type=style&index=0&id=9b04b9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b04b9b8",
  null
  
)

export default component.exports